<template>
  <div id="app">
    <ErrorBox 
      v-show="showError"
      :msg="errorMsg"
    />
    <Header 
      @showSignup="authFormView"
      @showSignin="authFormView"
      :showauthoptions="showAuthentication"
    />
    <div v-show="showform === 'signup'" class="flex center">
      <Signup
        @success="signupSuccess" 
        @error="signupError" 
      />
    </div>
    <div v-show="showform === 'signin'" class="flex center">
      <Signin/>
    </div>
    <div v-show="authenticationSuccess">
      <h1>Sign up Successful</h1>
    </div>
  </div>
</template>

<script>
import Header from './components/Header.vue'
import Signup from './components/Signup.vue'
import Signin from './components/Signin.vue'
import ErrorBox from './components/ErrorBox.vue'
import { requester } from './utilities/Requester.js'
window.version = 2;
export default {
  name: 'App',
  components: {
    Header,
    Signup,
    Signin,
    ErrorBox
  },
  data:function(){
    return {
      showAuthentication:true,
      showform:'none',
      showError:false,
      errorMsg:"",
      authenticationSuccess:false
    }
  },
  methods:{
    authFormView:function(e){
      this.showform = e 
    },
    signupSuccess:function(e){
      console.log(e);
      localStorage.setItem('ACCESS_TOKEN', e.access_token)
      localStorage.setItem('REFRESH_TOKEN', e.refresh_token)
      this.showAuthentication = false;
      this.authenticationSuccess = true;
    },
    signupError:function(e){
      console.log(e);
      this.errorMsg = e.message ? e.message : "Error cannot sign up"
      this.showError = true;
      setTimeout(() => {
        this.showError = false;
      }, 5000);
    }
  },
  created:function(){
    document.authRequest = requester("https://q33miligowwv02elw7fvdqx7ucam.restsoftware.com");     
    let accToken = localStorage.getItem('ACCESS_TOKEN')
    if(accToken !== null){
      this.showAuthentication = false;
      this.authenticationSuccess = true;
    }

  }
}
</script>

<style>
#app {
  position:relative;
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
body {
  margin:0;
}
.flex {
  display:flex;
}
.center {
  justify-content:center;
}
</style>
